<template>
  <el-card v-loading="loading" shadow="hover">
    <div style="padding: 10px 20px">
      <div v-if="editModel">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="兽医姓名" prop="vetName">
            <el-input placeholder="请输入兽医姓名" v-model="editModel.vetName"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="vetIdCard">
            <el-input
              placeholder="请输入身份证号"
              v-model="editModel.vetIdCard"
            ></el-input>
          </el-form-item>
          <el-form-item label="执业证号" prop="vetCertificateId">
            <el-input
              placeholder="请输入执业证书编号"
              v-model="editModel.vetCertificateId"
            ></el-input>
          </el-form-item>
          <el-form-item label="执业单位" prop="vetCompany">
            <el-input
              placeholder="请输入执业单位"
              v-model="editModel.vetCompany"
            ></el-input>
          </el-form-item>
          <el-form-item label="登录账号" prop="username">
            <el-input
              placeholder="请输入登录账号"
              v-model="editModel.username"
            ></el-input>
          </el-form-item>
          <el-form-item label="登录密码" prop="password">
            <el-input
              type="password"
              :placeholder="editModel.guid ? '不修改密码时请留空' : '请输入登录密码'"
              v-model="editModel.password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="签字印鉴" prop="signature">
            <signature-view ref="signature" v-model="editModel.signature" />
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="4"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              @submit.native.prevent
              @click="submitClick"
            >
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="fetchModel" size="small"> 重新加载 </el-button>
      </el-empty>
    </div>
  </el-card>
</template>

<script>
import signatureView from "../../../../components/signatureView.vue";

const defaultModel = {
  vetName: "",
  optStatus: 1,
};

export default {
  components: {
    signatureView,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        vetName: [
          {
            required: true,
            message: "请输入执业兽医名称",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          const method = this.editModel.guid
            ? "biz.customer.vet.doctor.update"
            : "biz.customer.vet.doctor.create";
          this.requestApi(method, this.editModel, {
            showError: true,
          })
            .then((resp) => {
              this.success("保存成功");
              this.$drawer.refreshDrawer();
              this.$drawer.backDrawer();
            })
            .finally(() => {
              this.editSubmit = false;
            });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
    },
    fetchModel() {
      const guid = this.pageParams.guid;
      if (!guid) {
        // 新增
        this.editModel = Object.assign({}, defaultModel);
        this.handleModel();
      } else {
        // 编辑
        this.errorMsg = null;
        this.loading = true;
        this.requestApi("biz.customer.vet.doctor.detail", {
          guid: this.pageParams.guid,
          storeGuid: this.pageParams.storeGuid,
        })
          .then((resp) => {
            this.editModel = resp.data;
            this.handleModel();
          })
          .catch((err) => {
            this.errorMsg =
              (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>
